import React, { useState } from "react";
import NavBarButton from "./NavBarButton";
import { ReactComponent as DashboardIcon } from "../assets/icons/dashboard.svg";
import { ReactComponent as DevicesIcon } from "../assets/icons/developer_board.svg";
import { ReactComponent as ProgramIcon } from "../assets/icons/code.svg";
import { ReactComponent as SettingsIcon } from "../assets/icons/settings.svg";
import { ReactComponent as DataIcon } from "../assets/icons/collection.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ReactComponent as MarketplaceIcon } from "../assets/icons/market.svg";
import { ReactComponent as MESIcon } from "../assets/icons/workspaces.svg";
import Logo from "../assets/images/boogie_logo.png";
import ActionButton from "./Buttons/ActionButton";
import MobileMenuItem from "./MobileMenuItem/MobileMenuItem";
import mes_tab_data from "../assets/mockedData/mes_tab_data";
import { useModuleAccess } from "../hooks/useModuleAccess";

type Props = {
  onClick: any;
};

const MobileMenu = (props: Props) => {
  //const [expanded, setExpanded] = useState(true)
  const [arrowState, setArrowState] = useState(false);
  const { canAccessModule, filterSidebarSections } = useModuleAccess();

  const handleDropDown = () => {
    setArrowState(!arrowState);
  };

  const develop_categories = [
    {
      id: 0,
      name: "Programs",
      to: "develop/programs",
      icon: "Program",
    },
    {
      id: 1,
      name: "Actions",
      to: "develop/actions",
      icon: "Action",
    },
    {
      id: 2,
      name: "Config",
      to: "develop/config",
      icon: "Config",
    },
  ];

  const marketplace_categories = [
    {
      id: 0,
      name: "Block-libraries",
      to: "marketplace/block-libraries",
      icon: "Dataset",
    },
    {
      id: 1,
      name: "Devices",
      to: "marketplace/devices",
      icon: "Config",
    },
  ];

  const data_catergories = [
    {
      id: 0,
      name: "Datasets",
      to: "data/datasets",
      icon: "Dataset",
    },
    {
      id: 1,
      name: "Models",
      to: "data/models",
      icon: "Model",
    },
    {
      id: 2,
      name: "Workers",
      to: "data/workers",
      icon: "Worker",
    },
    {
      id: 3,
      name: "Config",
      to: "data/config",
      icon: "Config",
    },
  ];

  // NavBarButton prepends the leading slash, so `to` is stored without one.
  const mes_categories = filterSidebarSections(mes_tab_data).flatMap(
    (section) =>
      (section.subItems ?? []).map((sub) => ({
        id: sub.path,
        name: sub.title,
        to: sub.path.replace(/^\//, ""),
        icon: "Dataset",
      }))
  );

  return (
    <div className="mobile-menu">
      <div className="mobile-menu-header">
        <img
          style={{ width: "30%" }}
          className="mobile-menu-header-image"
          src={Logo}
          alt="Rearm Robotics"
          // src="https://beta.poweriot.ai/wp-content/uploads/2022/05/PowerIoT_1000x200.png"
        />
        <ActionButton onClick={props.onClick} icon={<CloseIcon />} />
      </div>
      <div className="mobile-menu-body">
        <div style={{ height: "100%" }}>
          {canAccessModule("dashboard") && (
            <MobileMenuItem
              onClick={props.onClick}
              navbarPath="dashboard"
              navbarName="Dashboard"
              navbarIcon={<DashboardIcon />}
              dropDown={false}
            />
          )}
          {canAccessModule("devices") && (
            <MobileMenuItem
              onClick={props.onClick}
              navbarPath="devices"
              navbarName="Devices"
              navbarIcon={<DevicesIcon />}
              dropDown={false}
            />
          )}
          {canAccessModule("develop") && (
            <MobileMenuItem
              onClick={props.onClick}
              navbarPath="develop"
              navbarName="Develop"
              navbarIcon={<ProgramIcon />}
              dropDown={true}
              subcategories={develop_categories}
            />
          )}
          {canAccessModule("data") && (
            <MobileMenuItem
              onClick={props.onClick}
              navbarPath="data"
              navbarName="Data"
              navbarIcon={<DataIcon />}
              dropDown={true}
              subcategories={data_catergories}
            />
          )}
          {canAccessModule("mes") && (
            <MobileMenuItem
              onClick={props.onClick}
              navbarPath="mes"
              navbarName="MES"
              navbarIcon={<MESIcon />}
              dropDown={true}
              subcategories={mes_categories}
            />
          )}
          {/* <MobileMenuItem
            onClick={props.onClick}
            navbarPath="marketplace"
            navbarName="Marketplace"
            navbarIcon={<MarketplaceIcon />}
            dropDown={true}
            subcategories={marketplace_categories}
          /> */}
          {canAccessModule("settings") && (
            <MobileMenuItem
              onClick={props.onClick}
              navbarPath="settings"
              navbarName="Settings"
              navbarIcon={<SettingsIcon />}
              dropDown={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
